import { TabStyles } from '@tableau/widgets';
import React from 'react';

import { Messages } from '../../codegen/Localize';
import { imgPath } from '../../common/utilities/ImgUrl';
import { cssClass } from '../../style';

const cssPrefix = 'FlowOverviewFlowGraphImage';

const rootClass = cssClass(cssPrefix, 'root', {
  padding: TabStyles.Spacing.MediumSpace,
  maxWidth: '100%',
  overflow: 'auto'
});

const flowImageUnavailableContent = cssClass(cssPrefix, 'flowImageUnavailableContent', {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: '300px',
});

const flowImageUnavailableText = cssClass(cssPrefix, 'flowImageUnavailableText', {
  fontWeight: 'normal',
  color: TabStyles.Typography.Color.PrimaryLight,
  fontSize: TabStyles.Typography.Sizing.XLarge,
});

export type FlowOverviewFlowGraphImageProps = {
  readonly flowGraphImageUrl: string;
};

export class FlowOverviewFlowGraphImage extends React.PureComponent<FlowOverviewFlowGraphImageProps> {

  public render(): JSX.Element {
    return (
      <div className={rootClass}>
        {this.props.flowGraphImageUrl ? this.renderImage() : this.renderNoImageMessage()}
      </div>
    );
  }

  private renderImage(): JSX.Element {
    /* eslint-disable jsx-a11y/alt-text */
    return (
      <img src={this.props.flowGraphImageUrl}/>
    );
  }

  private renderNoImageMessage(): JSX.Element {
    /* eslint-disable jsx-a11y/alt-text */
    return (
      <div className={flowImageUnavailableContent}>
        <img src={imgPath('spaces_masthead_flow.svg')} />
        <div className={flowImageUnavailableText}>{Messages.flowImageUnavailable()}</div>
      </div>
    );
  }

}
